export default __webpack_public_path__ + "a419cf3d21041f086c141c919359ecd7.svg";